module.exports = __webpack_public_path__ + "static/img/mobile_overdue_member_validity_background.77c4c64a.png";